// extracted by mini-css-extract-plugin
export default {"popover":"VBFXpDXhIwf0H316WgAb3A==","dialog":"B1MK-3odvAc-K53R6SJo5w=="};